export const GET_BUILDING_COMPONENT_TYPE =
  '/building_component_type/get_building_component_type';
export const GET_SINGLE_BUILDING_COMPONENT_TYPE =
  '/building_component_type/get_single_building_component_type';
export const CREATE_BUILDING_COMPONENT_TYPE =
  '/building_component_type/create_building_component_type';
export const UPDATE_BUILDING_COMPONENT_TYPE =
  '/building_component_type/update_building_component_type';
export const REMOVE_BUILDING_COMPONENT_TYPE =
  '/building_component_type/remove_building_component_type';

export const CREATE_BUILDING_COMPONENT =
  'building_component/create_building_component';
export const UPDATE_BUILDING_COMPONENT =
  'building_component/update_building_component';
export const REMOVE_BUILDING_COMPONENT =
  'building_component/remove_building_component';

export const GET_ORDINANCE_REVISION_LIST = 'building/get_ordinance_revision_list';

export const FORM_DATA = {
  name: '',
  description: '',
  is_active: '',
  unit_value: '',
};
